<template>
	<div class="filter-game">
		<div class="sort-box">
			<van-dropdown-menu ref="dropdownMenu" v-if="filterData && filterData.sortList">
				<van-dropdown-item :title="sortCondition ? filterData.sortList[sortCondition] : '推荐排序'">
					<van-cell
						class="sort-item"
						v-for="(item, index) in filterData.sortList"
						:key="item"
						:title="item"
						@click="handleSortFilter(index)"
					>
						<img v-if="index == sortCondition" src="~@/images/new-home/primary-circel-select.png" alt="" />
					</van-cell>
				</van-dropdown-item>
			</van-dropdown-menu>
		</div>
		<div class="filter-box" @click="openFilter">
			筛选
			<span class="filter-num" v-if="advancedFilterLength > 0">{{ advancedFilterLength }}</span>
			<i class="filter-icon" v-else></i>
		</div>

		<van-popup
			class="filter-pop-up"
			v-model="filterPopUp"
			round
			position="bottom"
			get-container="body"
			@click-overlay="closeFilter"
		>
			<van-icon name="cross" class="filter-close" @click="closeFilter" />
			<div class="filter-title">
				高级筛选
			</div>
			<div class="filter-content">
				<div class="filter-item" v-if="gameType == 2">
					<div class="filter-item-title">设备系统</div>
					<ul class="filter-item-content">
						<li
							:class="[
								'select',
								{
									active: advancedFilterData['system'] && advancedFilterData['system'] == '0'
								}
							]"
							@click="handleAdvancedFilter({ paramName: 'system' }, { val: '0' })"
						>
							安卓
						</li>
						<li
							:class="[
								'select',
								{
									active: advancedFilterData['system'] && advancedFilterData['system'] == '1'
								}
							]"
							@click="handleAdvancedFilter({ paramName: 'system' }, { val: '1' })"
						>
							苹果
						</li>
					</ul>
				</div>
				<template v-if="filterData && filterData.queryList && filterData.queryList.length">
					<div class="filter-item" v-for="(item, index) in filterData.queryList" :key="index">
						<div class="filter-item-title">{{ item.showName }}</div>
						<div
							class="input-box"
							v-if="
								item &&
									item.ogss &&
									item.ogss.length &&
									item.ogss.findIndex((item) => item.val === '') >= 0
							"
						>
							<input
								type="number"
								placeholder="请输入"
								:value="
									advancedFilterData && advancedFilterData[item.paramName]
										? advancedFilterData[item.paramName].split('-')[0]
										: ''
								"
								@input="inputValue($event, item, 1)"
							/>
							<span>——</span>
							<input
								type="number"
								placeholder="请输入"
								:value="
									advancedFilterData && advancedFilterData[item.paramName]
										? advancedFilterData[item.paramName].split('-')[1]
										: ''
								"
								@input="inputValue($event, item, 2)"
							/>
						</div>

						<ul class="filter-item-content" v-if="item && item.ogss && item.ogss.length">
							<li
								:class="[
									'select',
									{
										active:
											advancedFilterData[item.paramName] &&
											advancedFilterData[item.paramName] == d.val
									}
								]"
								v-for="(d, i) in item.ogss"
								:key="i"
								v-show="d.val"
								@click="handleAdvancedFilter(item, d)"
							>
								{{ d.keyName }}
							</li>
						</ul>
					</div>
				</template>
			</div>
			<div class="filter-foot">
				<div class="filter-foot-btn" @click="resetFilter">重置</div>
				<div class="filter-foot-btn" @click="confirmFilter">确定</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { GetGameQueryConfigStore } from '@/service/getData';
export default {
	name: 'filter-game',
	props: {
		gameId: {
			type: Number,
			default: 0
		},
		gameType: {
			type: Number,
			default: 0
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			filterData: {},
			sortCondition: '',
			filterPopUp: false,
			advancedFilterData: {},
			advancedFilterDataOld: {}
		};
	},
	watch: {
		gameId() {
			this.clearCache();
			this.getGameQueryConfigStore();
		}
	},
	computed: {
		advancedFilterLength() {
			return Object.keys(this.advancedFilterData).length;
		}
	},
	created() {
		if (JSON.stringify(this.data) != '{}') {
			this.filterData = this.data;
		} else {
			this.getGameQueryConfigStore();
		}
	},
	mounted() {},
	methods: {
		getGameQueryConfigStore() {
			GetGameQueryConfigStore({ gameId: this.gameId }).then((res) => {
				if (res.data.code == '1') {
					this.filterData = res.data.result;
				}
			});
		},
		// 选择排序
		handleSortFilter(index) {
			if (this.sortCondition !== index) {
				this.sortCondition = index;
				this.$refs.dropdownMenu.toggleItem(false);
				this.$emit('handleSortFilter', {
					sortCondition: this.sortCondition
				});
			}
		},
		clearCache() {
			this.sortCondition = '';
			this.filterData = {};
			this.advancedFilterData = {};
			this.advancedFilterDataOld = {};
		},
		handleAdvancedFilter(item, d) {
			const newAdvancedFilterData = { ...this.advancedFilterData };
			if (newAdvancedFilterData[item.paramName] == d.val) {
				delete newAdvancedFilterData[item.paramName];
			} else {
				newAdvancedFilterData[item.paramName] = d.val;
			}
			this.advancedFilterData = newAdvancedFilterData;
		},
		inputValue(e, item, type) {
			const newAdvancedFilterData = { ...this.advancedFilterData };
			if (!newAdvancedFilterData[item.paramName]) {
				if (type == 1) {
					newAdvancedFilterData[item.paramName] = `${e.target.value}-`;
				} else {
					newAdvancedFilterData[item.paramName] = `-${e.target.value}`;
				}
			} else {
				let arr = newAdvancedFilterData[item.paramName].split('-');
				if (type == 1) {
					arr[0] = e.target.value;
				} else {
					arr[1] = e.target.value;
				}
				newAdvancedFilterData[item.paramName] = arr.join('-');
			}
			this.advancedFilterData = newAdvancedFilterData;
		},
		openFilter() {
			this.filterPopUp = true;
		},
		closeFilter() {
			this.advancedFilterData = { ...this.advancedFilterDataOld };
			this.filterPopUp = false;
		},
		resetFilter() {
			this.advancedFilterData = {};
			this.advancedFilterDataOld = {};
			this.filterPopUp = false;
			this.$emit('confirmFilter', this.advancedFilterData);
		},
		confirmFilter() {
			this.filterPopUp = false;
			this.advancedFilterDataOld = { ...this.advancedFilterData };
			this.$emit('confirmFilter', this.advancedFilterData);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../style/common';
.filter-game {
	width: 100%;
	height: 0.68rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	.filter-box,
	.sort-box {
		width: max-content;
	}
	/deep/ .van-dropdown-menu {
		height: 100%;
		.van-dropdown-menu__bar {
			width: 100%;
			height: 100%;
			background: transparent;
			box-shadow: none;
			justify-content: flex-start;
			.van-dropdown-menu__item {
				.van-dropdown-menu__title {
					.van-ellipsis {
						padding: 0;
						font-size: 0.26rem;
						line-height: 0.68rem;
						color: #8e92a5;
					}
					&::after {
						top: 62%;
						right: -0.1rem;
						transform-origin: 50% 0;
						transform: rotate(0deg);
						width: 0.14rem;
						height: 0.1rem;
						background: url('~@/images/new-home/down-icon-h.png') no-repeat;
						background-size: 100%;
						border: none;
						opacity: 1;
					}
				}
				.van-dropdown-menu__title--down {
					&::after {
						transform: rotate(180deg);
					}
				}
			}
		}
		.van-dropdown-item {
			height: 100vh;
			.van-popup {
				border-radius: 0 0 0.36rem 0.36rem;
				.sort-item {
					width: 100%;
					padding: 0 0.52rem 0 0.48rem;
					height: 0.84rem;
					display: flex;
					align-items: center;
					justify-content: space-between;
					&::after {
						display: none;
					}
					.van-cell__title {
						font-weight: 400;
						font-size: 0.28rem;
						color: #333333;
						line-height: 0.28rem;
						text-align: left;
						font-style: normal;
					}
					.van-cell__value {
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						img {
							width: 0.36rem;
							height: 0.36rem;
							object-fit: contain;
						}
					}
				}
			}
		}
	}
	.filter-box {
		text-align: right;
		height: 0.68rem;
		font-weight: 400;
		font-size: 0.26rem;
		color: #8e92a5;
		display: flex;
		align-items: center;
		.filter-icon {
			display: inline-block;
			margin-left: 0.08rem;
			width: 0.2rem;
			height: 0.2rem;
			background: url('~@/images/new-home/filter-icon-h.png') no-repeat;
			background-size: 100%;
		}
		.filter-num {
			margin-left: 0.08rem;
			box-sizing: border-box;
			padding: 0.04rem 0.08rem;
			width: 0.28rem;
			height: 0.28rem;
			background: rgba($color: #8e92a5, $alpha: 0.2);
			font-weight: 400;
			font-size: 0.2rem;
			color: #8e92a5;
			line-height: 0.2rem;
			border-radius: 0.2rem;
		}
	}
}
.filter-pop-up {
	width: 100%;
	max-height: 90%;
	min-height: 2.36rem;
	height: max-content;
	padding: 0 0.24rem;
	overflow-y: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	.filter-close {
		position: absolute;
		right: 0.38rem;
		top: 0.3rem;
		width: 0.48rem;
		height: 0.48rem;
		color: rgb(166, 171, 192);
		font-weight: 600;
		font-size: 0.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.filter-title {
		flex-shrink: 0;
		width: 100%;
		height: 1.08rem;
		background: #fefefe;
		font-weight: 600;
		font-size: 0.34rem;
		color: #2d2f35;
		line-height: 1.08rem;
		margin-bottom: 0.2rem;
	}
	.filter-content {
		overflow-y: scroll;
		.filter-item {
			margin-bottom: 0.48rem;
			.filter-item-title {
				font-size: 0.3rem;
				color: #2d2f35;
				line-height: 0.3rem;
				margin-bottom: 0.32rem;
			}
			.input-box {
				margin-bottom: 0.2rem;
				> input {
					width: 2.44rem;
					height: 0.52rem;
					background: #f3f4f8;
					border-radius: 0.26rem;
					text-align: center;
					font-size: 0.24rem;
					&::placeholder {
						color: #646775;
						font-size: 0.24rem;
					}
				}
			}
			.filter-item-content {
				display: flex;
				flex-wrap: wrap;
				.select {
					width: 2.18rem;
					height: 0.52rem;
					background: #f3f4f8;
					border-radius: 0.26rem;
					font-weight: 400;
					font-size: 0.24rem;
					color: #646775;
					line-height: 0.52rem;
					text-align: center;
					margin: 0.2rem 0 0 0.24rem;
					&:nth-of-type(3n + 1) {
						margin-left: 0;
					}
					&:nth-of-type(-n + 3) {
						margin-top: 0;
					}
				}
				.active {
					background: #508aff;
					color: #ffffff;
				}
			}
		}
	}
	.filter-foot {
		flex-shrink: 0;
		width: 100%;
		height: 1.28rem;
		background: #ffffff;
		box-shadow: inset 0 0.02rem 0 0 rgba(0, 0, 0, 0.06);
		border-radius: 0.02rem;
		display: flex;
		align-items: center;
		justify-content: center;
		.filter-foot-btn {
			width: 3.08rem;
			height: 0.9rem;
			border-radius: 0.45rem;
			border: 0.02rem solid #3eaffd;
			font-weight: 500;
			font-size: 0.3rem;
			color: #3eaffd;
			line-height: 0.9rem;
			letter-spacing: 0.02rem;
			text-align: center;
			&:nth-of-type(2) {
				margin-left: 0.26rem;
				border-color: transparent;
				background: linear-gradient(270deg, #a1d0ff 0%, #5695fc 100%);
				color: #ffffff;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/filter-game.vue